import React from 'react'
import {useSelector } from "react-redux";
import KeyFindingsDataWrapper from '../../../tdd-module/feature-bundle/key-findings/structure/KeyFindingsDataWrapper'
import Box from '@mui/material/Box';
import FullScreenDialog from '../../../tdd-module/feature-bundle/key-findings/dialog-full/FullScreenDialog'



const KeyFindingsHome = () => {
  // For PDD, use a simplified approach or disable defects functionality
  // const state = useSelector((state) => state.pddKeyFinding);
  const state = { fullMode: false }; // Simplified for PDD
  
  return (
    <>
    {state.fullMode ? 
    <FullScreenDialog
    open={state.fullMode}
    children={ <Box className={"h-100 w-100"}>
      <KeyFindingsDataWrapper/>
      </Box>}
    headerLabel = {"menu.defects"}
    />
     :
    <>
     <Box className={"h-100 w-100"}>
     <Box className={"h-100 w-100"}>
       <KeyFindingsDataWrapper />
     </Box>
   </Box>
   </>
    }
    </>
  )
}

export default KeyFindingsHome
